<template>
  <div class="subscription-group" :class="$vuetify.theme.dark ? 'shadow-dark' : 'shadow-light'">
    <v-tooltip bottom>
      <template v-slot:activator="{on, attrs}">
        <div
            v-bind="attrs"
            v-on="on"
            class="subscription-group__name"
        >
          {{ name }}
          <span class="tenant-name">
          -  {{ tenant }}
      </span>
        </div>
      </template>
      <div v-if="channels.length>0">
        <div
            v-for="(channelItem, channelIndex) in channels"
            :key="`channel-item-key-${channelIndex}`"
        >
          - {{ channelItem.description }}
        </div>
      </div>
      <div v-else class="no-results">no channels assigned</div>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <div class="subscription-group__description" v-bind="attrs" v-on="on">{{ description }}</div>
      </template>
      <span>{{ description }}</span>
    </v-tooltip>
    <div class="subscription-group__action">
      <v-menu>
        <template v-slot:activator="{ on }">
          <v-icon
              small
              v-on="on"
              style="height: 24px; width: 24px"
          >
            fas fa-cog
          </v-icon>
        </template>
        <v-list class="accent">
          <v-list-item
              v-for="(item, index) in actions"
              :key="index"
              :value="index"
              @click="item.action"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionGroup',
  props: {
    name: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    tenant: {
      type: String,
      default: ''
    },
    channels: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    actions() {
      return [
        {title: 'Assign', action: this.assignGroupHandler},
        {title: 'Edit', action: this.editGroupHandler},
        {title: 'Delete', action: this.deleteGroupHandler},
      ];
    }
  },
  methods: {
    /**
     * handle the assign group action and emit the corresponding event
     */
    assignGroupHandler() {
      this.$emit('assign');
    },
    /**
     * handle the edit group action and emit the corresponding event
     */
    editGroupHandler() {
      this.$emit('edit');
    },
    /**
     * handle the delete group action and emit the corresponding event
     */
    deleteGroupHandler() {
      this.$emit('delete');
    },
  }
}
</script>

<style lang="scss" scoped>
.subscription-group {
  flex-direction: row;
  justify-content: space-between;
  column-gap: 16px;
  display: grid;
  grid-template-columns: 8fr 10fr 1fr;
  width: 100%;
  max-width: 720px;
  padding: 8px;
  border: 1px solid #7a5aad;
  border-radius: 8px;
  cursor: default;

  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }

  &__name {
    border-right: 1px solid #1c6e59;

    .tenant-name {
      font-size: 0.8em;
      opacity: 0.8;
    }
  }

  &__description {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__action {
    display: flex;
    justify-content: center;
    cursor: pointer;
  }
}

.shadow-dark {
  box-shadow: 1px 0 8px rgb(0, 0, 0);
}

.shadow-light {
  box-shadow: 1px 0 2px rgba(0, 0, 0, 0.2);
}

.no-results {
  font-size: 0.8em;
  font-style: italic;
  opacity: 0.6;
  padding: 8px 16px;
}
</style>